import { Alert, Box, Button, Link } from "@mui/material"
import * as Sentry from "@sentry/react"
import { Component, type ErrorInfo, type ReactNode } from "react"

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
}

export class AuthErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    Sentry.captureException(error, { extra: { componentStack: errorInfo.componentStack } })
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh", p: 3 }}>
          <Alert severity="error" sx={{ maxWidth: 480 }}>
            <strong>Authentication error</strong>
            <Box sx={{ mt: 1 }}>
              Something went wrong with the authentication provider. Please try reloading the page.
            </Box>
            <Box sx={{ mt: 2, display: "flex", gap: 2, alignItems: "center" }}>
              <Button variant="contained" size="small" onClick={() => window.location.reload()}>
                Reload
              </Button>
              <Link href="/signout" underline="hover">
                Sign out
              </Link>
            </Box>
          </Alert>
        </Box>
      )
    }
    return this.props.children
  }
}
